import React, {Component} from 'react';
import {RouteComponentProps} from "react-router";
import NewWord from "../landing-content/new-word";
import Sure from "../landing-content/sure";
import WhatWeGot from "../landing-content/what-we-got";
import Reviews from "../landing-content/reviews";
import {Services} from "../landing-content/services/services";
import {LandingContainer} from "../landing-container/landing-container";
import {Helmet} from "react-helmet";

interface LandingProps extends RouteComponentProps {}

export default class Landing extends Component<LandingProps> {

    render() {
        return (
            <>
                <Helmet>
                    <title>LABRA - AI-система управления производительностью труда и HR-аналитики | Performance Management</title>
                    <meta name="description" content="LABRA - инновационная AI-платформа для повышения производительности труда, HR-аналитики и управления персоналом. Автоматизация аналитики, нормирование труда, KPI и управление эффективностью сотрудников."/>
                    <meta name="keywords" content="управление персоналом, производительность труда, HR аналитика, performance management, AI аналитика, автоматизация HR, эффективность труда, KPI сотрудников, нормирование труда, staffing"/>

                    {/* Open Graph */}
                    <meta property="og:title" content="LABRA - AI-система управления производительностью труда и HR-аналитики"/>
                    <meta property="og:description" content="Повышайте производительность труда на 25% с AI-аналитикой. Performance management, KPI сотрудников, нормирование труда."/>
                    <meta property="og:type" content="website"/>
                    <meta property="og:url" content="https://www.labrahub.ru/"/>
                    <meta property="og:image" content="https://www.labrahub.ru/images/logos/LABRA_logo.png"/>

                    {/* Twitter Card */}
                    <meta name="twitter:card" content="summary_large_image"/>
                    <meta name="twitter:title" content="LABRA - AI-система управления производительностью труда"/>
                    <meta name="twitter:description" content="Повышайте производительность труда на 25% с AI-аналитикой"/>
                    <meta name="twitter:image" content="https://www.labrahub.ru/images/logos/LABRA_logo.png"/>
                </Helmet>
                <LandingContainer>
                    <NewWord/>
                    <Sure/>
                    <Services/>
                    <WhatWeGot/>
                    <Reviews/>
                </LandingContainer>
            </>
        );
    };
}
